import React from 'react';

const ModalGalleryResponsive = () => {
    return (
        <div className="modal-gallery-responsive">
            <div className="big-image-gallery">
                <div className="swiper gallery-responsive-modal-swiper">
                    <div className="swiper-wrapper swiper-big-modal-image">
                    </div>
                </div>
            </div>
            <div className="thumbnail-slide position-relative">
                <div className="swiper thum-gallery-modal">
                    <div className="swiper-wrapper swiper-modal-responsive-wrapper">
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalGalleryResponsive;
